import { ApplicationStatus } from 'legacy/shared-types/enums/application-status.enum';

// Statuses where Valuation tab should be shown
const STATUSES_WITH_VALUATION: ApplicationStatus[] = [
  ApplicationStatus.FEES_PAID,
  ApplicationStatus.REVIEWING_APPLICATION,
  ApplicationStatus.OFFER_ISSUED,
  ApplicationStatus.OFFER_ACCEPTED,
  ApplicationStatus.OFFER_EXPIRED,
  ApplicationStatus.APPLICATION_DECLINED,
  ApplicationStatus.COMPLETION,
];

// Statuses where Post Offer tab should be shown
const STATUSES_WITH_POST_OFFER: ApplicationStatus[] = [
  ApplicationStatus.OFFER_ACCEPTED,
  ApplicationStatus.APPLICATION_DECLINED,
  ApplicationStatus.COMPLETION,
];

export const shouldShowValuationTab = (status: string): boolean => {
  return STATUSES_WITH_VALUATION.includes(status as ApplicationStatus);
};

export const shouldShowPostOfferTab = (status: string): boolean => {
  return STATUSES_WITH_POST_OFFER.includes(status as ApplicationStatus);
};
